import { EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
var DragDropDirective = (function () {
    function DragDropDirective(sanitizer) {
        this.sanitizer = sanitizer;
        this.files = new EventEmitter();
    }
    DragDropDirective.prototype.onDragOver = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    };
    DragDropDirective.prototype.onDragLeave = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    };
    DragDropDirective.prototype.onDrop = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var files = [];
        for (var i = 0; i < evt.dataTransfer.files.length; i++) {
            var file = evt.dataTransfer.files[i];
            files.push({ file: file });
        }
        if (files.length > 0) {
            this.files.emit(files);
        }
    };
    return DragDropDirective;
}());
export { DragDropDirective };



// WEBPACK FOOTER //
// /opt/app/src/app/features/list-code/link-code/drag-drop.directive.ts.pre-build-optimizer.js